import { render, staticRenderFns } from "./ProhibitMember.vue?vue&type=template&id=61ad9d55&"
import script from "./ProhibitMember.vue?vue&type=script&lang=ts&"
export * from "./ProhibitMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports